import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useAuth } from './context/AuthContext';
import Login from './Login';
import HomePage from './components/HomePage';
import NewsDashboard from './components/NewsDashboard';
import TeamDashboard from './components/TeamDashboard';
import TeamsForm from './components/TeamsForm';
import NewsForm from './components/NewsForm';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import theme from './theme';
import './App.css';
import NewsDetails from './components/NewsDetails';

function App() {
  const { isAuthenticated } = useAuth();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {/* Login Route */}
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} 
        />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={
            <Layout>
              <HomePage />
            </Layout>
          } />
          <Route path="/news" element={
            <Layout>
              <NewsDashboard />
            </Layout>
          } />
          <Route path="/news/add" element={
            <Layout>
              <NewsForm />
            </Layout>
          } />
          <Route path="/news/edit/:id" element={
            <Layout>
              <NewsForm />
            </Layout>
          } />
          <Route path="/team" element={
            <Layout>
              <TeamDashboard />
            </Layout>
          } />
          <Route path="/team/add" element={
            <Layout>
              <TeamsForm />
            </Layout>
          } />
          <Route path="/team/edit/:id" element={
            <Layout>
              <TeamsForm />
            </Layout>
          } />
          <Route path="/news/:id" element={
          <Layout>
            <NewsDetails />
          </Layout>
          } />
          {/* Add other protected routes here */}
        </Route>

        {/* Catch-all redirect */}
        <Route 
          path="*" 
          element={<Navigate to={isAuthenticated ? "/" : "/login"} replace />} 
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
